module.exports = __webpack_public_path__ + "img/learn.77590205.png";